import { render, staticRenderFns } from "./ProductiveUnitDetail.vue?vue&type=template&id=6ba1e60c&scoped=true&"
import script from "./ProductiveUnitDetail.vue?vue&type=script&lang=js&"
export * from "./ProductiveUnitDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductiveUnitDetail.vue?vue&type=style&index=0&id=6ba1e60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba1e60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
